import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12164_26195)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.527344 12.2818H3.76799V26.7563H0.527344V12.2818ZM17.5211 20.6891H20.7618V26.7563H17.5211V20.6891ZM11.8565 18.5197H15.0971V26.7563H11.8565V18.5197ZM6.19195 16.5633H9.43254V26.7563H6.19195V16.5633ZM22.6963 16.5679L21.9095 15.781C22.3314 15.4406 22.716 15.056 23.0564 14.6341L23.8433 15.421L24.198 15.0662C24.2454 15.0188 24.3228 15.0188 24.3701 15.0662L24.897 15.5929L22.8684 17.6215L22.3416 17.0947C22.2942 17.0473 22.2942 16.97 22.3416 16.9227L22.6963 16.5679ZM25.5598 16.2558L23.5312 18.2844L27.0257 21.7788C27.5835 22.3367 28.4964 22.3367 29.0542 21.7788C29.6122 21.2209 29.6122 20.3081 29.0542 19.7503L25.5598 16.2558ZM17.1572 3.24365C13.491 3.24365 10.519 6.2157 10.519 9.8818C10.519 13.548 13.491 16.5199 17.1572 16.5199C20.8233 16.5199 23.7953 13.5479 23.7953 9.8818C23.7954 6.2157 20.8233 3.24365 17.1572 3.24365ZM13.7327 13.0326C12.043 11.1971 12.1025 8.35555 13.8667 6.59135C15.6839 4.77412 18.6305 4.77412 20.4478 6.59135C22.212 8.35555 22.2714 11.1971 20.5818 13.0326C20.0687 12.4281 19.4071 11.9677 18.6592 11.7004C20.0173 10.7627 20.1998 8.82119 19.0286 7.64996C17.995 6.61643 16.3195 6.61643 15.2859 7.64996C14.115 8.8209 14.2969 10.7623 15.6553 11.7004C14.9075 11.9676 14.2457 12.4282 13.7327 13.0326ZM19.8841 13.653C18.2593 14.8299 16.055 14.8299 14.4304 13.6531C15.8613 11.9543 18.453 11.9543 19.8841 13.653ZM17.1572 7.81221C18.1012 7.81221 18.8663 8.57727 18.8663 9.52121C18.8663 11.0392 17.0225 11.8034 15.9488 10.7297C14.875 9.65598 15.6392 7.81221 17.1572 7.81221Z"
        fill="var(--tlx-color-azure-blue-400)"
      />
    </g>
    <defs>
      <clipPath id="clip0_12164_26195">
        <rect width="30" height="30" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
